__turbopack_context__.v({
  "content": "ticketOptions-module-scss-module__q44tMa__content",
  "current": "ticketOptions-module-scss-module__q44tMa__current",
  "hoverBg": "ticketOptions-module-scss-module__q44tMa__hoverBg",
  "initial": "ticketOptions-module-scss-module__q44tMa__initial",
  "inner": "ticketOptions-module-scss-module__q44tMa__inner",
  "left": "ticketOptions-module-scss-module__q44tMa__left",
  "link": "ticketOptions-module-scss-module__q44tMa__link",
  "option": "ticketOptions-module-scss-module__q44tMa__option",
  "options": "ticketOptions-module-scss-module__q44tMa__options",
  "previous": "ticketOptions-module-scss-module__q44tMa__previous",
  "price": "ticketOptions-module-scss-module__q44tMa__price",
  "second": "ticketOptions-module-scss-module__q44tMa__second",
  "space": "ticketOptions-module-scss-module__q44tMa__space",
  "ticket_options": "ticketOptions-module-scss-module__q44tMa__ticket_options",
  "title": "ticketOptions-module-scss-module__q44tMa__title",
  "top": "ticketOptions-module-scss-module__q44tMa__top",
});
